<script>
import {
  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  LinkedinIcon,
  MailIcon,
} from "vue-feather-icons";
export default {
  data() {
    return {};
  },
  components: {
    FacebookIcon,
    InstagramIcon,
    TwitterIcon,
    LinkedinIcon,
    MailIcon,
  },
};
</script>

<template>
  <div>
    <!-- Footer Start -->
    <footer class="footer">
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-12 mb-0 mb-md-4 pb-0 pb-md-2">
            <a href="#" class="logo-footer">
              <img src="images/storagebox_light.png" height="24" alt="" />
            </a>
            <p class="mt-4">
              Start storing with storagebox.ph and keep your personal belonging
              safe.
            </p>
            <ul class="list-unstyled social-icon social mb-0 mt-4">
              <li class="list-inline-item">
                <a
                  href="https://www.facebook.com/Storageboxph-105400935001163"
                  class="rounded"
                >
                  <facebook-icon class="fea icon-sm fea-social"></facebook-icon>
                </a>
              </li>
            </ul>
            <!--end icon-->
          </div>
          <!--end col-->

          <div class="col-lg-2 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0"></div>
          <!--end col-->

          <div class="col-lg-3 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0"></div>
          <!--end col-->

          <div class="col-lg-3 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
            <h5 class="text-light footer-head">Contact us</h5>
            <span class="text-foot"
              ><i class="mdi mdi-chevron-right mr-1"></i
              ><a href="mailto:hello@storagebox.ph"
                >hello@storagebox.ph</a
              ></span
            >
            <br />
            <span class="text-foot"
              ><i class="mdi mdi-chevron-right mr-1"></i>
              <a href="tel:+639178327166">+63917-832-7166</a></span
            >
            <br />
            <span class="text-foot"
              ><i class="mdi mdi-chevron-right mr-1"></i>
              <a href="tel:+63276221499">+632-7622-1499</a></span
            >
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </footer>
    <!--end footer-->
  </div>
</template>
